import { useForm, Controller } from "react-hook-form";
import QuickReply from ".";

const QuickReplyForm = () => {
    const form = useForm();
    return <QuickReply type={`quick-reply`} useForm={form} />
}
export default QuickReplyForm;
